var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox flex center",class:[{ checked: _vm.checked }],on:{"click":function($event){return _vm.$emit('click', _vm.checked)}}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }